export default "__VITE_ASSET__BGvDbTW6__"